import React from 'react';
import styles from './Default.scss';

const Default = ({
					 text = '',
					 color = '',
					 onClose = null,
					 duration = 0,
					 children = null,
					 confirmText = '',
					 onConfirm = null,
					 cancelText = '',
					 onCancel = null,
				 }) => {

	const showConfirm = !!confirmText && typeof onConfirm === 'function';
	const showCancel = !!cancelText && typeof onCancel === 'function';
	const showClose = typeof onClose === 'function';
	const showLoader = duration > 0;

	return (
	  <div
		className={`${styles.container}${showLoader ? ` ${styles.hasLoader}` : ''} ${color ? styles[color] : ''}`}
		role="status"
		aria-live="polite">

		  <div className={styles.content}>
			  {children
				? children
				: <span dangerouslySetInnerHTML={{__html: text}}/>
			  }
		  </div>

		  {(showConfirm || showCancel || showClose) && (
			<div className={styles.actions}>
				{showConfirm && (
				  <button
					type="button"
					className={styles.actionLink}
					onClick={onConfirm}
				  >
					  {confirmText}
				  </button>
				)}

				{showCancel && (
				  <button
					type="button"
					className={styles.actionLink}
					onClick={onCancel}
				  >
					  {cancelText}
				  </button>
				)}

				{showClose && (
				  <button
					type="button"
					className={styles.close}
					aria-label="Close"
					onClick={onClose}
				  />
				)}
			</div>
		  )}

		  {showLoader && (
			<div className={styles.notificationLoadingTrack}>
				<div
				  className={styles.notificationLoadingFill}
				  style={{animationDuration: `${duration}ms`}}
				/>
			</div>
		  )}
	  </div>
	);
};

export default Default;
